import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import EditIcon from '@mui/icons-material/Edit'
import InputDataIcon from '@mui/icons-material/DataObject'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { EditProps } from '../shared/EditProps'
import { useAuth } from '../../context/useAuth'

export default function EditInputData({ disabled, schema, value, setData }: EditProps) {
  const { name } = useParams()
  const { csrf } = useAuth()
  const [open, setOpen] = React.useState(false)

    return (
        <ButtonDialog
            disabled={disabled}
            title={`Edit Input Data`}
            icon={<InputDataIcon/>}
            iconButton={<EditIcon/>}
            content={
                <Form
                    onSubmit={async (e) => {
                        let fd = new FormData()
                        fd.append('data_type', e.formData.data_type)
                        fd.append('data_frequency', e.formData.data_frequency)
                        fd.append('file', e.formData.files)

                        try {
                            const res = await axios.put(`${process.env.REACT_APP_API}/${name}/input_data/${value.name}`,
                                fd,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'X-CSRFToken': csrf,
                                    },
                                    withCredentials: true,
                                })
                            setData(res.data)
                            setOpen(false)
                        } catch (err) {
                            console.log('err', err)
                        }
                    }}
                    validator={validator}
                    schema={schema as JSONSchema7}
                    formData={value}
                />
            }
            open={open}
            setOpen={setOpen}
        />
    )
}
